import React from "react";
import { useStyles } from "./styles";

export const NewsWidgetTitle = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.headerTitle} ref={ref}>
      {children}
    </div>
  );
};
NewsWidgetTitle.muiName = "NewsWidgetTitle";
NewsWidgetTitle.displayName = "NewsWidgetTitle";

export default NewsWidgetTitle;
